import PropTypes from 'prop-types'
import { AccelerationEventTypes } from '../../models/vehicle/acceleration-event-types-enum'

export const accelerationEventTypePropType = PropTypes.oneOf(Object.values(AccelerationEventTypes))
